import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useState } from 'react';

export const AddButton = (): JSX.Element => {
  const [spin, setSpin] = useState(false);

  const animate = (): void => {
    setSpin(true);

    setTimeout(() => setSpin(false), 500);
  };

  return <Button htmlType="submit" icon={<PlusOutlined />} style={{ background: 'lightgray', borderRadius: '50%' }} onClick={animate} className={spin ? `btn-spin` : undefined} />;
};
